import SocialMedia from "./SocialMedia.jsx";
export default SocialMedia